// @flow
import * as React from 'react';
import type { Location } from 'react-router';
import { OBJECT_TYPE_PLURAL_HUMAN_NAME_MAP } from 'utils/constants';
import SearchEmptyResultsMessage from './SearchEmptyResultsMessage';

export default ({
  query,
  filters,
  searchLocation,
  location,
  clearAllFilters
}: {
  query?: string,
  filters: Object,
  searchLocation?: Object,
  location: Location,
  clearAllFilters: Function
}) => {
  const resultType =
    filters.type === 'ALL' || !OBJECT_TYPE_PLURAL_HUMAN_NAME_MAP[filters.type]
      ? 'results'
      : OBJECT_TYPE_PLURAL_HUMAN_NAME_MAP[filters.type];

  return (
    <SearchEmptyResultsMessage
      allowSaveSearch
      query={query}
      searchLocation={searchLocation}
      resultType={resultType}
      clearAllFilters={clearAllFilters}
      location={location}
    />
  );
};
